module.exports = __webpack_public_path__ + "static/img/NP.2f809b42.svg";